export default {
    getStatusSpinner: state => {
        return state.spinner;
    },

}